import { baseApi, extractData } from "../api/axiosConfig";

export const deleteDataPointXref = id =>
    baseApi
        .delete(`/dataPointXref/${id}`)
        .then(extractData);

export const getXrefs = () =>
    baseApi
        .get("/dataPointXref/xrefsList")
        .then(extractData);

export const addDataPointXref = data =>
    baseApi
        .post("/dataPointXref", data)
        .then(extractData);

export const editDataPointXref = (id, data) =>
    baseApi
        .put(`/dataPointXref/${id}`, data)
        .then(extractData);

export const getDataPointXrefByDataPointId = dataPointId =>
    baseApi
        .get("/dataPointXref/dataPointId", {
            params: {
                dataPointId
            }
        })
        .then(extractData);

// import fetch from 'unfetch';
// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteDataPointXref = id =>
// axios.delete(`${BASE_URL}/api/contramatic/dataPointXref/${id}`, {
//     headers: {
//         'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//     }
// })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getXrefs = () =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointXref/xrefsList`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addDataPointXref = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/dataPointXref`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log("here's my abcd");
//             console.log({abcd});
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// // export const editContractDataPoint = (selectorContractDataPointId, abcd) =>
// export const editDataPointXref = (id, abcd) =>
//     axios.put(`${BASE_URL}/api/contramatic/dataPointXref/${id}`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //         {params:{contractLevel: abcd.contractLevel,
//         //                 contractSectionId: Number(abcd.contractSectionId),
//         // dataPoint: {id: Number(abcd.dataPointId)},
//         //                 destinationFolder: abcd.destinationFolder,
//         //                 ordinalNumber: Number(abcd.ordinalNumber),
//         //                 // version_ind: false}}
//         // versionInd: false}
//         // }
//         // }
//         //     )
//         //         //
//         //         abcd)
//         .then(function (response) {
//             // console.log("here's my id");
//             // console.log({selectorContractDataPointId});
//             console.log("here's my abcd");
//             console.log({abcd});
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("here's my id");
//                 // console.log({selectorContractDataPointId});
//                 console.log("here's my abcd error 1");
//                 console.log({abcd});
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log("here's my id");
//                 // console.log({selectorContractDataPointId});
//                 console.log("here's my abcd error 2");
//                 console.log({abcd});
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log("here's my id");
//                 // console.log({selectorContractDataPointId});
//                 console.log("here's my abcd error 3");
//                 console.log({abcd});
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// // https://stackoverflow.com/questions/48980380/returning-data-from-axios-api#48980526
// export function getDataPointXrefByDataPointId(dataPointId) {
//     return     axios.get(`${BASE_URL}/api/contramatic/dataPointXref/dataPointId`
//         ,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 dataPointId: dataPointId
//             }
//         }
//     )
//         // .then(response => response.data)
// // .then(console.log("this is my response"))
// // .then(   console.log(data))
// };
//
//
